import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRef } from "react";
import { categories } from "../data/products";

const categoryImages = {
  "Tümü": "/category-images/all.png",
  "Mutfak Bıçağı": "/category-images/kitchen.jpg",
  "Kamp Bıçağı": "/category-images/camp-knife.jpg",
  "Set Bıçak": "/category-images/knife-set.png",
  "Çakı & Multitool": "/category-images/multitool.jpg",
  "Kamp Ekipmanı": "/category-images/camp-equipment.jpg",
  "Aydınlatma": "/category-images/lighting.jpg",
  "Termos & Matara": "/category-images/thermos.jpg",
  "Güvenlik & İlk Yardım": "/category-images/first-aid.jpg",
  "Koleksiyon": "/category-images/collection.png",
};

export default function CategoryCircleFilter({ selected, onSelect }) {
  const railRef = useRef(null);
  const scroll = (direction) => {
    railRef.current?.scrollBy({ left: direction * 360, behavior: "smooth" });
  };

  return (
    <section className="border-y border-stone-200 bg-cream px-3 py-4 sm:px-5 md:px-10">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => scroll(-1)}
          aria-label="Kategorileri sola kaydır"
          className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-full border border-stone-200 bg-white text-stone-800 shadow-sm hover:border-red-500 hover:text-red-600 sm:flex"
        >
          <ChevronLeft size={20} />
        </button>

        <div ref={railRef} className="flex flex-1 gap-4 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {categories.map((category) => {
            const active = selected === category;
            return (
              <button
                key={category}
                type="button"
                onClick={() => onSelect(category)}
                className="group flex w-[82px] shrink-0 flex-col items-center gap-2 text-center outline-none"
                aria-pressed={active}
              >
                <span
                  className={`relative h-16 w-16 overflow-hidden rounded-full border bg-white transition ${
                    active
                      ? "border-stone-950 shadow-[0_0_0_4px_rgba(28,25,23,0.12)]"
                      : "border-stone-200 shadow-sm group-hover:border-red-500"
                  }`}
                >
                  <img
                    src={categoryImages[category] || categoryImages["Tümü"]}
                    alt=""
                    className={`h-full w-full object-cover transition duration-300 group-hover:scale-110 ${active ? "scale-105" : ""}`}
                  />
                  <span className={`absolute inset-0 transition ${active ? "bg-stone-950/10" : "bg-transparent group-hover:bg-red-900/5"}`} />
                </span>
                <span className={`line-clamp-2 min-h-[34px] text-xs font-semibold leading-tight ${active ? "text-stone-950" : "text-stone-600"}`}>
                  {category}
                </span>
              </button>
            );
          })}
        </div>

        <button
          type="button"
          onClick={() => scroll(1)}
          aria-label="Kategorileri sağa kaydır"
          className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-full border border-stone-200 bg-white text-stone-800 shadow-sm hover:border-red-500 hover:text-red-600 sm:flex"
        >
          <ChevronRight size={20} />
        </button>
      </div>
    </section>
  );
}
